<template>
    <ul class="lang" ref="navLang">
        <li data-lang="fr" @click="changeLang" class="active">fr</li>
        <li data-lang="en" @click="changeLang">en</li>
    </ul>
</template>

<script>
export default {
    name: 'ToggleLanguage',
    methods: {
        changeLang: function(e){
            let target = e.currentTarget
            this.$refs.navLang.querySelector('.active').classList.remove('active')
            target.classList.add('active')
            this.$i18n.set(target.getAttribute('data-lang'))
        }
    }
}
</script>

<style lang="scss">
    @import './toggleLanguage';
</style>



// WEBPACK FOOTER //
// src/components/ToggleLanguage/ToggleLanguage.vue